import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function AdminIndex() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/posts/blog", { replace: true });
  }, [navigate]);

  return null;
}
